import React, { useEffect, useState } from "react";
import AdsServiceCard from "../../../../components/common/adsServiceCard";
import AdsNewService from "../../../../components/ads/adsNewService";
import Button from "../../../../components/common/button";
import { colors } from "../../../../share/constants/enums";
import { useNavigate } from "react-router-dom";
import { Carousel, Pagination, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { addAds } from "../../../../api/ads";
import { fetchService } from "../../../../store/slices/serviceSlice";

const NewAds = () => {
  const [value, setValue] = useState({
    days: "",
    type: "",
    date: "",
    city: "",
    state: "",
    offer: "",
  });
  const [activeCardId, setActiveCardId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPagesize] = useState(4);
  const [loader, setLoader] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const dispatch = useDispatch();
  const handleSizeChange = (current, size) => {
    setPagesize(size);
  };

  const handleCardClick = (id) => {
    setActiveCardId(id === activeCardId ? null : id);
  };
  const navigate = useNavigate();
  const allServices = useSelector((state) => state?.service?.value?.service);
  const buttonSubmit = async () => {
    setLoader(true);
    const allNonEmpty = Object.values(value).every((value) => value !== "");

    if (allNonEmpty && activeCardId) {
      const payload = {
        numberOfDays: value?.days,
        startDate: value?.date,
        city: value?.city,
        state: value?.state,
        advertisementTypeId: value?.type,
        serviceId: activeCardId,
        offerTypeId: value?.offer,
      };
      const res = await addAds(payload);
      navigate("/main/ads/pending-ads", {
        state: {
          adsData: value,
          serviceId: activeCardId,
        },
      });
      message.success("Your Ads is created. Please wait for Admin's Approval");
    } else {
      message.error("Please fill all fields and service!!");
    }
    setLoader(false);
  };
  useEffect(() => {
    const payload = {
      pageNumber: currentPage,
      pageSize: pageSize,
    };
    dispatch(fetchService(payload));
  }, [currentPage, pageSize]);

  return (
    <>
      <div className="p-2">
        <div>
          <p className="text-lg font-medium tracking-wider">
            Select Services for Advertisement
          </p>
        </div>
        {/* <Carousel> */}{" "}
        <div className="flex mx-auto grid grid-cols-1 sm:grid sm:grid-cols-4 gap-2 mb-2 justify-between w-full">
          {allServices?.items?.slice(0, 4)?.map((item, i) => (
            <AdsServiceCard
              data={item}
              key={i}
              isActive={item?._id === activeCardId}
              onClick={() => handleCardClick(item?._id)}
            />
          ))}
        </div>{" "}
        <div className="flex justify-center items-center pagination-container mb-2">
          <Pagination
            current={currentPage}
            total={allServices?.totalItems}
            pageSize={pageSize}
            pageSizeOptions={[4, 10, 20, 30]}
            onShowSizeChange={handleSizeChange}
            onChange={(e) => {
              handlePageChange(e);
            }}
          />
        </div>
        <div>
          <AdsNewService
            value={value}
            dropData={(val) => {
              setValue(val);
            }}
          />
        </div>
        <div className="flex mt-1 justify-end  sm:ml-auto">
          <Button
            title={"Submit"}
            color={colors.primaryPurple}
            loading={loader}
            className={"w-19"}
            onClick={buttonSubmit}
          />
        </div>
      </div>
    </>
  );
};

export default NewAds;
